var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 25V17M17.8 21H25M13 17H8.2C5.96348 17 4.84522 17 3.96312 17.406C2.78698 17.9473 1.85255 18.9855 1.36538 20.2924C1 21.2725 1 22.515 1 25M17.2 1.38768C18.9591 2.17886 20.2 4.09508 20.2 6.33333C20.2 8.57159 18.9591 10.4878 17.2 11.279M14.8 6.33333C14.8 9.27885 12.651 11.6667 10 11.6667C7.34903 11.6667 5.2 9.27885 5.2 6.33333C5.2 3.38781 7.34903 1 10 1C12.651 1 14.8 3.38781 14.8 6.33333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateChatIcon);
export default __webpack_public_path__ + "static/media/create_chat_icon.3dfce6ce59ae3344b73f8af6c2a0df5d.svg";
export { ForwardRef as ReactComponent };